export const TIMEZONE_OFFSET_OPTIONS = [
  {
    label: 'GMT-12:00',
    value: 60 * 12,
  },
  {
    label: 'GMT-11:00',
    value: 60 * 11,
  },
  {
    label: 'GMT-10:00',
    value: 60 * 10,
  },
  {
    label: 'GMT-09:00',
    value: 60 * 9,
  },
  {
    label: 'GMT-08:00',
    value: 60 * 8,
  },
  {
    label: 'GMT-07:00',
    value: 60 * 7,
  },
  {
    label: 'GMT-06:00',
    value: 60 * 6,
  },
  {
    label: 'GMT-05:00',
    value: 60 * 5,
  },
  {
    label: 'GMT-04:00',
    value: 60 * 4,
  },
  {
    label: 'GMT-03:00',
    value: 60 * 3,
  },
  {
    label: 'GMT-02:00',
    value: 60 * 2,
  },
  {
    label: 'GMT-01:00',
    value: 60 * 1,
  },
  {
    label: 'GMT+00:00',
    value: 0,
  },
  {
    label: 'GMT+01:00',
    value: -60 * 1,
  },
  {
    label: 'GMT+02:00',
    value: -60 * 2,
  },
  {
    label: 'GMT+03:00',
    value: -60 * 3,
  },
  {
    label: 'GMT+03:30',
    value: -60 * 3.5,
  },
  {
    label: 'GMT+04:00',
    value: -60 * 4,
  },
  {
    label: 'GMT+04:30',
    value: -60 * 4.5,
  },
  {
    label: 'GMT+05:00',
    value: -60 * 5,
  },
  {
    label: 'GMT+05:30',
    value: -60 * 5.5,
  },
  {
    label: 'GMT+05:45',
    value: -60 * 5.75,
  },
  {
    label: 'GMT+06:00',
    value: -60 * 6,
  },
  {
    label: 'GMT+06:30',
    value: -60 * 6.5,
  },
  {
    label: 'GMT+07:00',
    value: -60 * 7,
  },
  {
    label: 'GMT+08:00',
    value: -60 * 8,
  },
  {
    label: 'GMT+09:00',
    value: -60 * 9,
  },
  {
    label: 'GMT+09:30',
    value: -60 * 9.5,
  },
  {
    label: 'GMT+10:00',
    value: -60 * 10,
  },
  {
    label: 'GMT+11:00',
    value: -60 * 11,
  },
  {
    label: 'GMT+12:00',
    value: -60 * 12,
  },
];
